/**
 * 描画開始位置オフセット取得
 * @param {Number} width 幅
 * @param {Number} height 高さ
 * @returns {Object} オフセット(x, y)
 */
const getDrawSquareParam = (width, height) => {
  const diff = Math.abs(width - height)
  if (width > height) {
    return { sx: diff / 2, sy: 0, size: Math.min(width, height) }
  } else {
    return { sx: 0, sy: diff / 2, size: Math.min(width, height) }
  }
}

// 画像形式定義
const IMAGE_TYPE = {
  DATA_URL: 'dataURL',
  IMAGE_BITMAP: 'imageBitmap',
  IMAGE_DATA: 'imageData',
  CANVAS: 'canvas',
  BLOB: 'blob',
}

/**
 * 画像を円形にクリップするクラス
 */
class ImageRoundClipper {
  /**
   * クリッピング
   * @param {Image} img イメージソース(url, width, height)
   * @param {String} resultType 結果イメージの形式('dataURL', 'imageData', 'canvas', 'blob')
   * @returns {Object} クリップ後イメージ
   */
  async clip(img, resultType) {
    const { width, height } = img
    const radius = Math.min(width / 2, height / 2)
    const size = radius * 2

    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')

    ctx.beginPath()
    ctx.arc(radius, radius, radius, 0, Math.PI * 2)
    ctx.clip()

    const { sx, sy } = getDrawSquareParam(width, height)
    ctx.drawImage(img, sx, sy, size, size, 0, 0, size, size)

    let image
    switch (resultType) {
      case IMAGE_TYPE.IMAGE_DATA:
        image = ctx.getImageData(0, 0, width, height)
        break
      case IMAGE_TYPE.IMAGE_BITMAP:
        image = await createImageBitmap(ctx.getImageData(0, 0, width, height))
        break
      case IMAGE_TYPE.CANVAS:
        image = canvas
        break
      case IMAGE_TYPE.BLOB:
        image = canvas.toBlob()
        break
      default:
        image = canvas.toDataURL()
        break
    }
    if (resultType !== IMAGE_TYPE.CANVAS) {
      canvas.remove()
    }
    return { image, size }
  }
}

export default new ImageRoundClipper()
